import { Container, Avatar, Box, Grid, Table, TableBody, TableRow, TableCell, Card, TextField, TableHead, Button, CircularProgress, TextareaAutosize } from "@mui/material";
import React, { useEffect, useState } from "react";
import John from '../../../../assets/john.png';
import '../Form/Form.css';
import moment from "moment";
import './AnnualAppraisal.css';
import Select from "react-select";
import { useDispatch } from "react-redux";
import { axiosFetch } from "../../../../utils/AxiosFetch";
import { SnackbarActions } from "../../../../redux/actions/snackbar.actions";
import { useNavigate, useParams } from "react-router";
import EmployeeQuestion from "./EmployeeQuestion";
import ManagerQuestion from "./ManagerQuestion";
import { ConfirmationModal } from "../../../../shared";


function AppraisalForm() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();

    const [employeQuestion, setEmployeQuestion] = useState([]);
    const [managerQuestion, setManagerQuestion] = useState([]);
    const [managerSubQuestion, setManagerSubQuestion] = useState([]);
    const [appraisalFields, setAppraisalFields] = useState({});
    const [profileDetail, setProfileDetail] = useState(null);
    const [reportingPersonId, setReportingPersonId] = useState("");
    const [userType, setUserType] = useState("");
    const [employeeId, setEmployeeId] = useState("");
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [hrComment, setHrComment] = useState("");
    var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";
    const [draftLoading, setDraftLoading] = useState(false);
    const [empSubmitLoading, setEmpSubmitLoading] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false)
    const [approveConfirm,setApproveConfirm] = useState(false);


    useEffect(() => {
        fetchQuestions()
    }, []);

    const handleConfirmationModal = () => {
        if (openConfirm) {
            setOpenConfirm(false)
            setTimeout(() => {
                setApproveConfirm(false)
              }, "3000")
            
        }
        else {
            setOpenConfirm(true)
        }
    }
    const handleFormSubmit = () => {
        if(approveConfirm){
            confirmApprove()
        }
        else{
            handleEmpReview(true, 0);
        }
    }

    const fetchQuestions = () => {
        axiosFetch({
            url: `/Performance/appraisal/questions/${parseInt(id)}`,
            method: "get",
        })
            .then((res) => {
                if (res.status === 200) {

                    var result = res.data.result;
                    var appraisal = result.appraisalFields
                    loadProfileDetails(appraisal.userId);
                    setEmployeQuestion(result.questions);
                    setManagerQuestion(result.managerQuestions);
                    setManagerSubQuestion(result.subQuestions);
                    setAppraisalFields(appraisal);
                    if (appraisal.hrComments !== null) {
                        setHrComment(appraisal.hrComments)
                    }
                    console.log(res.data)
                }
                if (res.status === 400) {
                    if(res.data === "You are not an authorised user"){
                        dispatch(SnackbarActions(true, "error", res.data));
                        setTimeout(()=>{
                            navigate("/annual-appraisal");
                        },3000)

                    }
                    else{
                        dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));

                    }
                }
                if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const loadProfileDetails = () => {
        axiosFetch({
            method: "get",
            url: `/Performance/appraisal/employee/profile/${id}`
        })
            .then((res) => {
                if (res.status === 200) {
                    if (res.data.result !== null) {
                        setProfileDetail(res.data.result);
                        setReportingPersonId(res.data.result.reportingPersonId);
                        setEmployeeId(res.data.result.id);
                        setUserType(res.data.result.userType);
                    }

                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })

            .catch(err => {
                console.error(err);
            })
    }

    const handleHRSubmit = (isSubmit) => {
        if (hrComment !== "") {
            var req = {
                "id": id,
                "hRComments": hrComment,
                "isSubmit": isSubmit
            }
            if (isSubmit === true) {
                setLoading(true)
            }
            else {
                setSubmitLoading(true)
            }
            axiosFetch({
                method: "post",
                url: `/Performance/appraisal/update`,
                requestConfig: req

            })
                .then((res) => {
                    if (res.status === 200) {
                        fetchQuestions();
                        dispatch(SnackbarActions(true, "success", "Your comment has been updated successfully"));
                        if (isSubmit === true) {
                            setLoading(false)
                        }
                        else {
                            setSubmitLoading(false)
                        }
                        navigate('/annual-appraisal')
                    }
                    else if (res.status === 400) {
                        setSubmitLoading(false)

                        setLoading(false)
                        dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                    }
                    else if (res.status === 401) {
                        navigate('/');
                    }
                })

                .catch(err => {
                    console.error(err);
                })
        }
        else {
            dispatch(SnackbarActions(true, "warning", "Please fill out hr comment"));
        }
    }
    const handleEmpReview = (isSubmit, isConfirm) => {

        var questions = [];
        var objects;
        employeQuestion.filter(list => (list.questionFor === "Review" && document.getElementById("empReview" + list.questionId).value !== "")).map((list) => {
            objects = {
                "questionId": list.questionId,
                "comments": document.getElementById("empReview" + list.questionId).value,
            }
            questions.push(objects)

        })
        var req = {
            "id": id,
            "isSubmit": isSubmit,
            "questions": questions.length > 0 ? questions : null
        }
        console.log(req)
        if (questions !== null) {
            if (isSubmit === false) {
                handleSubmit(req)
                setDraftLoading(true)

            }
            else if (isSubmit === true && employeQuestion.filter(list => (list.questionFor === "Review" && document.getElementById("empReview" + list.questionId).value !== "")).length === employeQuestion.filter(list => list.questionFor === "Review").length) {
                if (isConfirm === 0) {
                    handleSubmit(req)
                    setEmpSubmitLoading(true)
                }
                else {
                    handleConfirmationModal()
                }

            }
            else {
                dispatch(SnackbarActions(true, "warning", "Please fill out the questions"));
            }
        }
    }

    const handleSubmit = (req, isSubmit) => {
        axiosFetch({
            method: "post",
            url: `/Performance/appraisal/employee/review`,
            requestConfig: req

        })
            .then((res) => {
                if (res.status === 200) {
                    fetchQuestions();
                    dispatch(SnackbarActions(true, "success", "Your response has been updated successfully"));
                    setEmpSubmitLoading(false)
                    setDraftLoading(false)
                    if (isSubmit) {
                        navigate("/annual-appraisal");
                    }
                }
                else if (res.status === 400) {
                    setEmpSubmitLoading(false)
                    setDraftLoading(false)
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })

            .catch(err => {
                console.error(err);
            })
    }
    const handleApprove = () => {
        setApproveConfirm(true)
        handleConfirmationModal()       
    }
    const confirmApprove = () => {
         axiosFetch({
            url: `/performance/appraisal/complete/${id}`,
            method: 'post',
        })
            .then((res) => {
                if (res.status === 200) {
                    dispatch(SnackbarActions(true, "success", " Approved Successfully!"));
                    navigate('/annual-appraisal');
                } else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", `${res.data}`));
                }
                else if (res.status === 401) {
                    window.location.href = '/';
                }
            })
    }
    return (
        <div className="argus-pmp-module">
            <div className="note">
                {/* <Container fixed> */}
                <Box sx={{ bgcolor: '#cfe8fc', padding: '25px', borderRadius: "10px", height: "20%", border: "1px solid #abd5ff" }}>
                    <h2 className="header">Note to the Team Member / Appraisee</h2>
                    <p>Appraisals are not just about pay and job titles, this appraisal is primarily about discussing and discovering how to enable you to get the most from your position at Aggregate Intelligence - how to maximize your enjoyment, your engagement and your value to the organization (and therefore to yourself). Our focus is on the future rather than the past, and the purpose of this appraisal is to discover how to better position you for future success within the organization. Please be candid and honest with your appraiser - the more feedback you give, the better the company can understand your value and help to make you more successful! </p>
                    <div className='fw-bolder user-msg'>
                        <Avatar alt="John Tilly" src={John} />
                        <div className='john-msg'>
                            <strong style={{ color: " #113776" }}>John Tilly, CEO, Aggregate Intelligence</strong><br />
                            <i>jtilly@aggregateintelligence.com</i>
                        </div>
                    </div>
                </Box>
                {/* </Container> */}
                <div className="note">
                    {/* <Container fixed> */}
                    <Card className='variable-pay'>
                        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={6}>
                                <h2 className="pmp-headings">Team Member / Appraisee</h2>
                                <Table className="score-table argus-table left-table">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Name</TableCell>
                                            <TableCell>
                                                {profileDetail !== null && profileDetail.firstName !== null ? profileDetail.lastName !== null ? profileDetail.firstName + " " + profileDetail.lastName : profileDetail.firstName : "-"}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Emp ID</TableCell>
                                            <TableCell>
                                                {profileDetail !== null && profileDetail.employeeCode !== null ? profileDetail.employeeCode : "-"}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Department Name / Team Name</TableCell>
                                            <TableCell>
                                                {profileDetail !== null && profileDetail.departmentName !== null ? profileDetail.teamName !== null ? profileDetail.departmentName + "/" + profileDetail.teamName : profileDetail.departmentName : "-"}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Job Title</TableCell>
                                            <TableCell>
                                                {profileDetail !== null && profileDetail.jobTitleName !== null ? profileDetail.jobTitleName : "-"}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Reports To</TableCell>
                                            <TableCell>
                                                {profileDetail !== null && profileDetail.reportingPersonFirstName !== null ? profileDetail.reportingPersonFirstName + " " + profileDetail.reportingPersonLastName : "-"}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Current Gross[Month]</TableCell>
                                            <TableCell>
                                                {profileDetail !== null && profileDetail.ctc !== null ? "-" : "-"}
                                            </TableCell>
                                        </TableRow>

                                    </TableBody>
                                </Table>
                            </Grid>
                            <Grid item xs={6}>
                                <h2 className="pmp-headings">Reporting Manager / Appraiser</h2>
                                <Table className="score-table argus-table left-table">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Name</TableCell>
                                            <TableCell>
                                                {profileDetail !== null && profileDetail.reportingPersonFirstName !== null ? profileDetail.reportingPersonLastName !== null ? profileDetail.reportingPersonFirstName + " " + profileDetail.reportingPersonLastName : profileDetail.reportingPersonFirstName : "-"}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Emp ID</TableCell>
                                            <TableCell>
                                                {profileDetail !== null && profileDetail.reportingPersonEmpCode !== null ? profileDetail.reportingPersonEmpCode !== "0000" ? profileDetail.reportingPersonEmpCode : "-" : "-"}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Department / Team Name</TableCell>
                                            <TableCell>
                                                {profileDetail !== null && profileDetail.reportingPersonDepartmentName !== null ? profileDetail.reportingPersonTeam !== null ? profileDetail.reportingPersonDepartmentName + "/" + profileDetail.reportingPersonTeam : profileDetail.departmentName : "-"}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Job Title</TableCell>
                                            <TableCell>
                                                {profileDetail !== null && profileDetail.reportingPersonJobTitle !== null ? profileDetail.reportingPersonJobTitle : "-"}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Date of Appraisal</TableCell>
                                            <TableCell>
                                                {moment().format('DD-MMM-YYYY')}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Date of Last  Appraisal</TableCell>
                                            <TableCell>
                                                -
                                                {/* {profileDetail !== null && profileDetail.lastAppraisalDate !== null ? moment(profileDetail.lastAppraisalDate).format('DD-MMM-YYYY') : "-"} */}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Grid>
                        </Grid>
                        <br />

                    </Card>
                    {/* </Container> */}

                </div>
                <div className="note">
                    {/* <Container fixed> */}
                    <Card className='variable-pay'>
                        <h2 className="pmp-headings">To be filled by Team Member / Appraisee</h2>
                        <p>Please complete this section before meeting for your review.</p>
                        <EmployeeQuestion question={employeQuestion} formId={id} appraisal={appraisalFields} loadQuestions={fetchQuestions} profileDetail={profileDetail} />

                    </Card>
                    {/* </Container> */}
                </div>
                {appraisalFields.statusName !== "Opened" ?
                    <div className="note">
                        {/* <Container fixed> */}
                        <Card className='variable-pay'>
                            <h2 className="pmp-headings">To be filled by Reporting Manager / Appraiser</h2>
                            <ManagerQuestion managerQuestion={managerQuestion} managerSubQuestion={managerSubQuestion} loadQuestions={fetchQuestions} formId={id} appraisal={appraisalFields} reportingManagerId={profileDetail && profileDetail.reportingPersonId ? profileDetail.reportingPersonId : null} profileDetail={profileDetail} />
                            {appraisalFields.statusId === 7 && parseInt(profileDetail && profileDetail.reviewerManagerId) === isUserLogged.userid? 
                            <Button variant="contained" className="theme-btn"
                                            onClick={() => handleApprove()}
                                        >Approve</Button>:""}
                        </Card>
                        {/* </Container> */}
                    </div> : ""}
                {appraisalFields.statusId !== 7 && (isUserLogged.usertype === "SuperAdmin" || isUserLogged.usertype === "HRManager" || appraisalFields.statusName === "Re Assign" || appraisalFields.statusName === "Moved to HR") &&
                    (isUserLogged.userid !== (appraisalFields && appraisalFields.userId)) 
                    // && (isUserLogged.userid !== (profileDetail && profileDetail.reportingPersonId)) 
                    ?

                    <div className="note">
                        {/* <Container fixed> */}
                        <Card className='variable-pay'>
                            <h2 className="pmp-headings">To be filled by HR</h2>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <label className="form-label col-form-label">HR Comments :</label>
                                    <TextField fullWidth value={hrComment} onChange={(e) => setHrComment(e.target.value)} 
                                    disabled={appraisalFields.statusId !== 3 && appraisalFields.statusName !== "Re Assign"} />
                                </Grid>
                                <Grid item xs={12}>

                                    {loading ?
                                        <CircularProgress size='2rem' sx={{ float: "right", marginRight: "10px" }} /> :
                                        <Button variant="contained" className="theme-btn"
                                            onClick={() => handleHRSubmit(true)}
                                        disabled={(appraisalFields.statusId  !== 3 && appraisalFields.statusName !== "Re Assign") || submitLoading === true}
                                        >Submit</Button>}

                                    {submitLoading ?
                                        <CircularProgress size='2rem' sx={{ float: "right", marginRight: "10px" }} /> :
                                        <Button variant="contained" className="theme-btn cancel-btn" style={{ marginRight: "10px" }}
                                            onClick={() => handleHRSubmit(false)}
                                        disabled={(appraisalFields.statusId  !== 3 && appraisalFields.statusName !== "Re Assign") || loading === true}
                                        >Re-Assign</Button>}
                                </Grid>
                            </Grid>
                        </Card>
                        {/* </Container> */}
                    </div> : <></>}
                {appraisalFields.statusName === "Employee Review" || appraisalFields.statusName === "Completed" ?
                    <div className="note">
                        {/* <Container fixed> */}
                        <Card className='variable-pay'>
                            <h2 className="pmp-headings">To be filled by Team Member / Appraisee</h2>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    {employeQuestion.length > 0 ?
                                        employeQuestion.filter(list => list.questionFor === "Review").map((list) => {
                                            return (
                                                <Grid item xs={12} className="argus-qa">
                                                    <p className="questions">{(list.questionId) - 2}. {list.question} </p>
                                                    <Box
                                                        component="form"
                                                        className="answers"

                                                        noValidate
                                                        autoComplete="off"
                                                    >
                                                        <TextareaAutosize
                                                            id={"empReview" + list.questionId}
                                                            multiline
                                                            fullWidth
                                                            maxRows={3}
                                                            className="argus-answers"
                                                            variant="outlined"
                                                            defaultValue={list.comments}
                                                            disabled={(appraisalFields.statusName !== "Employee Review") || (parseInt(isUserLogged.userid) !== parseInt(appraisalFields.userId))}
                                                        />
                                                    </Box>
                                                </Grid>
                                            )
                                        })
                                        : <></>}
                                </Grid>
                                <Grid item xs={12}>

                                    {empSubmitLoading ?
                                        <CircularProgress size='2rem' sx={{ float: "right" }} /> :
                                        <Button variant="contained" className="theme-btn"
                                            onClick={() => handleEmpReview(true, 1)}
                                            disabled={appraisalFields.statusName !== "Employee Review" || draftLoading === true || (parseInt(isUserLogged.userid) !== parseInt(appraisalFields.userId))}
                                        >Submit</Button>}

                                    {draftLoading ?
                                        <CircularProgress size='2rem' sx={{ float: "right", marginRight: "10px" }} /> :
                                        <Button variant="contained" className="theme-btn cancel-btn" style={{ marginRight: "10px" }}
                                            onClick={() => handleEmpReview(false, 0)}
                                            disabled={appraisalFields.statusName !== "Employee Review" || empSubmitLoading === true || (parseInt(isUserLogged.userid) !== parseInt(appraisalFields.userId))}
                                        >Save as Draft</Button>}
                                </Grid>
                            </Grid>
                        </Card>
                        {/* </Container> */}
                    </div> : <></>}
                <ConfirmationModal open={openConfirm} handleClose={handleConfirmationModal} message={approveConfirm?"Are you sure to approve this form?":"You cannot edit the form after submitting it. Are you sure you want to submit the form?"} handleYes={handleFormSubmit} />


            </div>
        </div>
    )
}

export default AppraisalForm;